import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Pain } from './components/sections/Pain';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCTA, Footer } from './components/sections/FinalCTA';
interface AppProps {
  showPurchasePopup?: boolean;
  showFloatingCta?: boolean;
}
export function App({
  showPurchasePopup = true,
  showFloatingCta = true
}: AppProps) {
  return <div className="w-full overflow-x-hidden bg-ink-950 font-sans antialiased" data-id="element-0" data-mp="23vupcfiil0w7">
      <MetaPixel data-id="element-1" data-mp="3ijxsv0nzqion" />
      <main data-id="element-2" data-mp="3ikh5q2ysagvt">
        <Hero data-id="element-3" data-mp="3iiwf2oflbi38" />
        <Problem data-id="element-4" data-mp="3ijfx0558q6h9" />
        <Pain data-id="element-5" data-mp="3ihv22ef0kliv" />
        <Volumes data-id="element-6" data-mp="3ii4q3wgi0ilx" />
        <Bonuses data-id="element-7" data-mp="3mlat8v8bdto6" />
        <Offer data-id="element-8" data-mp="3mkrgdsxitvh0" />
        <Testimonials data-id="element-9" data-mp="3mk84asujy1aw" />
        <About data-id="element-10" data-mp="3mjg9hk8s47lo" />
        <Faq data-id="element-11" data-mp="3mj6lu3b7icj5" />
        <FinalCTA data-id="element-12" data-mp="3rcj7c4kla37o" />
      </main>
      <Footer data-id="element-13" data-mp="3rdatkosaqola" />
      {showFloatingCta && <FloatingCTA data-id="element-14" data-mp="3recdlirailf5" />}
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="67z9oh5w26u" />}
    </div>;
}